import React, { useEffect } from "react";
import { trackEvent, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";

function PressCoverage() {
  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
          <div className="w-16 h-16 rounded-full bg-[#1a4a1a]/10 flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-[#1a4a1a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 2v4M8 2v4M3 10h18" />
            </svg>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a1a] mb-4">
            Press Coverage Coming Soon
          </h2>
          <p className="text-[#1a4a1a]/90 text-lg mb-8 max-w-2xl mx-auto">
            We're working on bringing you the latest news and media coverage about HalalCred's mission to revolutionize Islamic financing. Stay tuned for updates about our journey in making halal financing more accessible.
          </p>
          <div className="text-sm text-[#1a4a1a]/70 mt-6">
            For media inquiries, please contact us at <a href="mailto:media@halalcred.com" className="font-semibold hover:text-[#1a4a1a] underline">salaam@halalcred.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PressCoverage; 